import * as React from 'react'
import { Box, Fab, CircularProgress, Tooltip } from '@mui/material'
import { Edit, Delete, ToggleOn, ToggleOff } from '@mui/icons-material'
import { green, orange, blue, red } from '@mui/material/colors'
import { enableTenant, disableTenant } from '../../../services/tenantService'

const TenantActions = ({ params, onEdit, onDelete, onRefresh }) => {
  const [loading, setLoading] = React.useState(false)

  const handleToggleStatus = async () => {
    setLoading(true)
    const { id, enabled, habilitado } = params.row
    const isEnabled = enabled !== undefined ? enabled : habilitado

    const result = isEnabled ? await disableTenant(id) : await enableTenant(id)
    if (result?.success && onRefresh) {
      onRefresh()
    }
    setLoading(false)
  }

  const isEnabled = params.row.enabled !== undefined ? params.row.enabled : params.row.habilitado

  return (
    <Box sx={{ m: 1, position: 'relative', display: 'flex', gap: 1 }}>
      <Tooltip title="Editar">
        <span>
          <Fab
            sx={{
              width: 36,
              height: 36,
              bgcolor: blue[500],
              '&:hover': { bgcolor: blue[700] },
            }}
            disabled={loading}
            onClick={() => onEdit(params.row)}>
            <Edit fontSize="small" sx={{ color: '#fff' }} />
          </Fab>
        </span>
      </Tooltip>

      <Tooltip title={isEnabled ? 'Deshabilitar' : 'Habilitar'}>
        <span>
          <Fab
            sx={{
              width: 36,
              height: 36,
              bgcolor: isEnabled ? orange[500] : green[500],
              '&:hover': {
                bgcolor: isEnabled ? orange[700] : green[700],
              },
            }}
            disabled={loading}
            onClick={handleToggleStatus}>
            {isEnabled ? (
              <ToggleOff fontSize="small" />
            ) : (
              <ToggleOn fontSize="small" />
            )}
          </Fab>
        </span>
      </Tooltip>

      <Tooltip title="Eliminar">
        <span>
          <Fab
            sx={{
              width: 36,
              height: 36,
              bgcolor: red[500],
              '&:hover': { bgcolor: red[700] },
            }}
            disabled={loading}
            onClick={() => onDelete(params.row)}>
            <Delete fontSize="small" sx={{ color: '#fff' }} />
          </Fab>
        </span>
      </Tooltip>

      {loading && (
        <CircularProgress
          size={44}
          sx={{ color: green[500], position: 'absolute', top: -4, left: -4, zIndex: 1 }}
        />
      )}
    </Box>
  )
}

export default TenantActions
